function isHasRoute (name, routes) {
  let hasRoute = false
  routes.forEach(item => {
    
    if (name == item.name) {
      hasRoute = true
    } else {
      if (item.children && item.children.length) {
        if (isHasRoute(name, item.children)) {
          hasRoute = true
        }
      }
    }
  })
  return hasRoute
}

export default isHasRoute